import { ProgramsRouteName } from '.';
import { AppRouteConfig, breadcrumbs } from '..';

export function publishedRoutes(): Array<AppRouteConfig> {
	return [
		{
			path: '',
			name: ProgramsRouteName.publishedList,
			component: () => import('../../views/program/PublishedList.vue'),
			meta: {
				breadcrumbs: [
					breadcrumbs.get('home'),
					breadcrumbs.get('publishedPrograms'),
				],
				maskFeature: ['programs'],
			},
		},
		{
			path: ':programId/proposal-and-evaluation',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: ProgramsRouteName.proposalAndEvaluationList,
					component: () =>
						import('../../views/program/ProposalAndEvaluationList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('publishedPrograms'),
							breadcrumbs.get('proposalAndEvaluation'),
						],
						caslSubject: 'programs.program_forms',
						caslAction: 'view',
						maskFeature: ['programs.proposalAndEvaluation'],
					},
				},
			],
		},
		{
			path: ':programId/proposals/:proposalId/advance-requests',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: ProgramsRouteName.advancePaymentRequestList,
					component: () =>
						import('../../views/program/AdvancePaymentRequestList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('publishedPrograms'),
							breadcrumbs.get('proposalAndEvaluation'),
							breadcrumbs.get('advancePaymentRequest'),
						],
						caslSubject: 'programs.program_forms',
						caslAction: 'view',
					},
				},
				{
					path: 'new',
					name: ProgramsRouteName.newAdvancePaymentRequest,
					component: () =>
						import(
							'../../views/program/advance-payment-request/AdvancePaymentRequestEdit.vue'
						),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('publishedPrograms'),
							breadcrumbs.get('proposalAndEvaluation'),
							breadcrumbs.get('advancePaymentRequest'),
							breadcrumbs.get('createAdvancePaymentRequest'),
						],
						caslSubject: 'programs.program_forms',
						caslAction: 'edit',
					},
				},
				{
					path: ':id',
					name: ProgramsRouteName.editAdvancePaymentRequest,
					component: () =>
						import(
							'../../views/program/advance-payment-request/AdvancePaymentRequestEdit.vue'
						),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('publishedPrograms'),
							breadcrumbs.get('proposalAndEvaluation'),
							breadcrumbs.get('advancePaymentRequest'),
							breadcrumbs.get('advancePaymentRequestName'),
						],
						caslSubject: 'programs.program_forms',
						caslAction: 'view',
					},
				},
			],
		},
		{
			path: ':programId/reports',
			component: { render: c => c('router-view') },
			children: [
				{
					path: '',
					name: ProgramsRouteName.programReportList,
					component: () => import('../../views/program/ProgramReportList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('publishedPrograms'),
							breadcrumbs.get('programReports'),
						],
						caslSubject: 'programs.program_reports',
						caslAction: 'view',
						maskFeature: ['programs.reports'],
					},
				},
				{
					path: ':reportId/event-list',
					component: { render: c => c('router-view') },
					children: [
						{
							path: '',
							name: ProgramsRouteName.programEventList,
							component: () =>
								import('../../views/program/ProgramEventList.vue'),
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('publishedPrograms'),
									breadcrumbs.get('programReports'),
									breadcrumbs.get('programEventDetails'),
								],
							},
						},
						{
							path: 'jobs',
							name: ProgramsRouteName.ProgramEventJobDetailsList,
							component: () => import('../../views/job/AllList.vue'),
							props: { jobListType: 'all' },
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('publishedPrograms'),
									breadcrumbs.get('programReports'),
									breadcrumbs.get('programEventDetails'),
									breadcrumbs.get('jobAll'),
								],
							},
						},
						{
							path: 'events',
							name: ProgramsRouteName.ProgramEventEventDetailsList,
							component: () => import('../../views/event/AllList.vue'),
							props: { eventListType: 'all' },
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('publishedPrograms'),
									breadcrumbs.get('programReports'),
									breadcrumbs.get('programEventDetails'),
									breadcrumbs.get('eventAll'),
								],
							},
						},
						{
							path: 'add-job',
							name: ProgramsRouteName.programEventAddJob,
							component: () =>
								import('../../views/program/ProgramEventJobList.vue'),
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('publishedPrograms'),
									breadcrumbs.get('programReports'),
									breadcrumbs.get('programEventDetails'),
									breadcrumbs.get('programEventAddJobs'),
								],
							},
						},
						{
							path: 'add-event',
							name: ProgramsRouteName.programEventAddEvent,
							component: () =>
								import('../../views/program/ProgramEventEventList.vue'),
							meta: {
								breadcrumbs: [
									breadcrumbs.get('home'),
									breadcrumbs.get('publishedPrograms'),
									breadcrumbs.get('programReports'),
									breadcrumbs.get('programEventDetails'),
									breadcrumbs.get('programEventAddEvents'),
								],
							},
						},
					],
				},
				{
					path: ':reportId/funder-report',
					name: ProgramsRouteName.programReportFunderReport,
					component: () =>
						import('../../views/program/ProgramFunderReportList.vue'),
					meta: {
						breadcrumbs: [
							breadcrumbs.get('home'),
							breadcrumbs.get('publishedPrograms'),
							breadcrumbs.get('programEventDetails'),
							breadcrumbs.get('funderReport'),
						],
					},
				},
			],
		},
	];
}
